import React from 'react'
import {Route,Switch} from 'react-router-dom'
import {pages, PrivateRoute, AuthenticationRoute} from "./components"

import {Footer, Header, TeamSwitcherModal} from "./components/ui"
import {authenticationHelpers, provisioningHelpers} from "./dataHelpers"
import Websocket from "react-websocket"
import {WS_URL} from "./api"
import {User} from "./models"
import 'bootstrap/dist/css/bootstrap.css'
import './stylesheets/App.css'


class App extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            user: null,
            token: null,
            loadingUser: true,
            teamSwitcherModalVisible: false,
            refreshTokenTimer: null,
        }

        this.handleWebSocketResponse = this.handleWebSocketResponse.bind(this)
        this.toggleTeamSwitcherModal = this.toggleTeamSwitcherModal.bind(this)
        this.onTeamSwitch = this.onTeamSwitch.bind(this)

        this.loadToken = this.loadToken.bind(this)
        this.clearToken = this.clearToken.bind(this)
        this.updateToken = this.updateToken.bind(this)
    }

    async componentWillMount() {
        try {
            this.setState({loadingUser: true})
            await this.loadToken()
            let {token} = this.state
            let user = await authenticationHelpers.loadUser(token)
            await this.setState({user, loadingUser: false})
        } catch (err) {
            this.setState({loadingUser: false})
        }
        console.log("NODE ENV IS ")
        console.log(process.env.NODE_ENV)
        console.log(process.env)
    }


    async componentWillReceiveProps(nextProps) {
        let {user, token} = this.state
        if (!user || !token) {
            try {
                this.setState({loadingUser: true})
                await this.loadToken()
                let {token} = this.state
                let user = await authenticationHelpers.loadUser(token)
                await this.setState({user, loadingUser: false})
            } catch (err) {
                this.setState({loadingUser: false})
            }
        }
    }

    async loadToken() {
        let {refreshTokenTimer, token} = this.state
        try {
            token = await authenticationHelpers.loadToken(this.updateToken, this.clearToken)
            if (token && token.accessToken && token.refreshToken) {
                refreshTokenTimer = authenticationHelpers.setRefreshTokenTimer(refreshTokenTimer, token.secondsUntilShouldRefresh, this.updateToken)
            }
        } catch (err) {
        } finally {
            this.setState({token, refreshTokenTimer})
        }
    }

    async updateToken(oldToken) {
        let {refreshTokenTimer, token} = this.state
        try {
            let tokenToUpdate = oldToken || token
            token = await authenticationHelpers.updateToken(tokenToUpdate)
            clearInterval(refreshTokenTimer)
            refreshTokenTimer = authenticationHelpers.setRefreshTokenTimer(refreshTokenTimer, token.secondsUntilShouldRefresh, this.updateToken)
            this.setState({token, refreshTokenTimer})
        } catch (err) {
            clearInterval(refreshTokenTimer)
            this.setState({token, refreshTokenTimer})
        }
    }

    async clearToken(oldToken) {
        await authenticationHelpers.clearToken()
        this.setState({token: null, refreshTokenTimer: null})
    }

    async handleWebSocketResponse(data) {
        let result = JSON.parse(data)
        let oldUser = this.state.user
        let user = User.fromAPIObject(result)
        let activeTeam = oldUser.activeTeam

        if (!user.teams || !user.teams.includes(activeTeam)) {
            activeTeam = user.activeTeam
            authenticationHelpers.getStorage().setItem(authenticationHelpers.CURRENT_TEAM_KEY, activeTeam)
            authenticationHelpers.getStorage().setItem(authenticationHelpers.USER_STORAGE_KEY, JSON.stringify(user))
            this.setState({user})
        } else {
            user.activeTeam = activeTeam
            this.setState({user})
            authenticationHelpers.getStorage().setItem(authenticationHelpers.USER_STORAGE_KEY, JSON.stringify(user))
        }
    }

    /* Function to Create new subscription plan */
    async addSubscription(selectSubsId, selectSubsName, subsSeasoned, controllerId) {
        let subsResponse = await provisioningHelpers.addSubscription(selectSubsId, selectSubsName, subsSeasoned, controllerId)
        let error = subsResponse.error
        if (error) {
            let errors = [error,]
            this.setState({errors})
            return
        }
        return subsResponse
    }
    /* End of function */

    render() {
        let path = this.props.location.pathname
        let {user, token, teamSwitcherModalVisible, refreshTokenTimer, loadingUser} = this.state
        let teamID = authenticationHelpers.getCurrentTeam()

        let isAuthenticated = user && token
        let isAuthenticatedAsDealer = user && token && (user.isDealer || user.isSupport)
        let isAuthenticatedAsSupport = user && token && user.isSupport

        return <div className="app">
            <Header path={path}
                    user={user}
                    currentTeamID={teamID}
                    history={this.props.history}
                    token={token}
                    toggleTeamSwitcherModal={this.toggleTeamSwitcherModal}/>
            <div className="container app-container">
                { loadingUser ? null :
                    <Switch>
                        <AuthenticationRoute exact path="/login"
                                                component={pages.authentication.LogInPage}
                                                authenticated={isAuthenticated}
                                                componentProps={{
                                                    onComplete: async (user, token) => {
                                                        await this.setState({user, token})
                                                    }
                                                }}/>
                        <AuthenticationRoute exact path="/signup"
                                             component={pages.authentication.SignUpPage}
                                             authenticated={isAuthenticated}/>
                        <AuthenticationRoute exact path="/forgot"
                                             component={pages.authentication.ForgotPasswordPage}
                                             authenticated={isAuthenticated}/>
                        <PrivateRoute exact path="/logout" component={pages.authentication.LogOutPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{
                                          token,
                                          refreshTokenTimer,
                                          onComplete: async () => {
                                              await this.setState({
                                                  user: null,
                                                  token: null,
                                                  refreshTokenTimer: null
                                              })
                                              window.location.reload()
                                          }
                                      }}/>
                        <PrivateRoute exact path="/account" component={pages.users.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/users/:user_id" component={pages.users.ViewPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/team" component={pages.teams.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/team/integrations/jdo/authredirect" component={pages.teams.AuthCodeHandlerPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/team/integrations/jdo/orgredirect" component={pages.teams.ExternalOrgConnectionPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/teams/:team_id" component={pages.teams.ViewPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/teams/:team_id/controllers" component={pages.controllers.ListPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/controllers" component={pages.controllers.ListPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/controllers/:controller_id" component={pages.controllers.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token, activeTab: 1}}/>
                        <PrivateRoute exact path="/controllers/:controller_id/settings"
                                      component={pages.controllers.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token, activeTab: '2'}}/>
                        <PrivateRoute exact path="/controllers/:controller_id/trends" component={pages.controllers.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token, activeTab: '3'}}/>
                        <PrivateRoute exact path="/controllers/:controller_id/logs" component={pages.controllers.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token, activeTab: '4'}}/>
                        <PrivateRoute exact path="/controllers/:controller_id/about" component={pages.controllers.ViewPage}
                                      authenticated={isAuthenticated}
                                      componentProps={{user, token, activeTab: '5'}}/>
                        <PrivateRoute exact path="/management/controllers/provision"
                                      component={pages.controllers.ProvisionPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token}}/>

                        <PrivateRoute exact path="/management/teams" component={pages.teams.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/transfercontrol" component={pages.controllers.TransferController}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>              

                        /* These are routes from an early version of the site. */
                        <PrivateRoute exact path="/management/teams/customers" component={pages.teams.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/teams/dealers" component={pages.teams.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>

                        /* These are routes from subscription additions. */
                        <PrivateRoute exact path="/management/controllers/subscriptionsetting"
                                       authenticated={isAuthenticatedAsSupport}
                                       component={pages.subscription.SubscriptionSetting}
                                       componentProps={{token, onSubmit:this.addSubscription}}/>
                        <PrivateRoute exact path="/management/controllers/subscription" component={pages.subscription.SubscriptionController}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user, onSubmit: this.addSubscription}}/>
                        <PrivateRoute exact path="/management/controllers/subscriptioninitialplan" component={pages.subscription.EditSubscriptionPlan}
                                      authenticated={isAuthenticatedAsSupport}
                                list      componentProps={{token, user, onSubmit:this.addSubscription}}/>
                        <PrivateRoute exact path="/management/controllers/subscriptionsetting/extendsubscription" component={pages.subscription.ExtendSubscription}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user, teamID}}/>
                        <PrivateRoute exact path="/management/controllers/subscriptionplanlist" component={pages.subscription.SubscriptionPlanList}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user, teamID}}/>
                        <PrivateRoute exact path="/management/controllers/discountsetting" component={pages.subscription.DiscountSetting}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/controllers/discountlabelsetting" component={pages.subscription.DiscountLabelSetting}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/controllers/discountlabellist" component={pages.subscription.DiscountLabelList}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/controllers/editdiscountlabel" component={pages.subscription.EditDiscountLabel}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/controllers/editassigneddiscount" component={pages.subscription.EditAssignedDiscount}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/controllers/teamdiscountlist" component={pages.subscription.TeamDiscountList}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/applicationsetting" component={pages.subscription.ApplicationSettingPanel}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/subsdefaultplan" component={pages.subscription.SubscriptionDefaultPlan}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/paymenthistory" component={pages.subscription.PaymentHistory}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/dealer/controllers/invoice" component={pages.subscription.Invoice}
                                      authenticated={isAuthenticatedAsDealer}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/support/controllers/invoice" component={pages.subscription.InvoiceForSupport}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/support/controllers/reports" component={pages.subscription.Reports}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/aboutexpiredays" component={pages.subscription.SetAboutExpireDays}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                       
                        /* End of routes for subscription additions */


                        <PrivateRoute exact path="/management/teams/provision/customer" component={pages.teams.CreatePage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user, isSupport: true}}/>
                        <PrivateRoute exact path="/management/teams/provision/dealer" component={pages.teams.CreatePage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user, provisionAsDealer: true, isSupport: true}}/>
                        <PrivateRoute exact path="/management/users" component={pages.users.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        <PrivateRoute exact path="/management/support" component={pages.utilities.ControlPanelPage}
                                      authenticated={isAuthenticatedAsSupport} componentProps={{user}}/>
                        <PrivateRoute exact path="/management/controllers" component={pages.controllers.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token}}/>
                        /* This is a route from an early version of the site. Keeping this here for SFE */
                        <PrivateRoute exact path="/management/status" component={pages.controllers.SearchPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/management/controllers/assign" component={pages.controllers.AssignPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token, isSupport: true}}/>
                        <PrivateRoute exact path="/management/controllers/unassign"
                                      component={pages.controllers.UnassignPage}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{user, token, isSupport: true}}/>
                        <PrivateRoute exact path="/dealer" component={pages.utilities.ControlPanelPage}
                                      authenticated={isAuthenticatedAsDealer} componentProps={{user}}/>
                        <PrivateRoute exact path="/dealer/teams/provision" component={pages.teams.CreatePage}
                                      authenticated={isAuthenticatedAsDealer}
                                      componentProps={{token, user, isSupport: false}}/>
                        <PrivateRoute exact path="/dealer/controllers/assign" component={pages.controllers.AssignPage}
                                      authenticated={isAuthenticatedAsDealer}
                                      componentProps={{user, token, isSupport: false}}/>
                        <PrivateRoute exact path="/dealer/controllers/unassign" component={pages.controllers.UnassignPage}
                                      authenticated={isAuthenticatedAsDealer}
                                      componentProps={{user, token, isSupport: false}}/>
                        <PrivateRoute exact path="/dealer/controllers/register" component={pages.controllers.RegisterPage}
                                      authenticated={isAuthenticatedAsDealer}
                                      componentProps={{user, token}}/>
                        <PrivateRoute exact path="/management/celldecoder" component={pages.utilities.CellDecoder}
                                      authenticated={isAuthenticatedAsSupport}
                                      componentProps={{token, user}}/>
                        
                        <Route exact path="/unauthorized" component={pages.errors.UnauthorizedPage}/>
                        {isAuthenticatedAsSupport ?
                            <Route exact path="/" render={(routeProps) => (
                                <pages.utilities.ControlPanelPage {...routeProps} user={user} token={token} isSupport={true}/>)}/>:
                            (isAuthenticated ?
                                <Route exact path="/" render={(routeProps) => (
                                    <pages.controllers.ListPage {...routeProps} user={user} token={token}/>)}/>:
                                <Route exact path="/" render={(routeProps) => (
                                    <pages.authentication.LogInPage {...routeProps}
                                                                    onComplete={async (user, token) => {
                                                                        await this.setState({user, token})
                                                                    }}/>)}/>)
                        }
                        <Route path="*" component={pages.errors.NotFoundPage}/>
                    </Switch>}
            </div>
            <Footer/>


            {(token && user ?
                <TeamSwitcherModal modal={teamSwitcherModalVisible}
                                   toggle={this.toggleTeamSwitcherModal}
                                   teamIDs={user.teams}
                                   currentTeamID={teamID}
                                   userID={user.id}
                                   token={token}
                                   onTeamSwitch={this.onTeamSwitch}/> :
                null)}

            {(token && user ?
                <Websocket url={`${WS_URL}/users/${user.id}/?access_token=${token.accessToken}`}
                           onMessage={this.handleWebSocketResponse}/> :
                null)}
        </div>
    }

    toggleTeamSwitcherModal() {
        this.setState({
            teamSwitcherModalVisible: !this.state.teamSwitcherModalVisible
        })
    }

    async onTeamSwitch(newTeamID) {
        await authenticationHelpers.setCurrentTeam(newTeamID)
        let {user} = this.state
        user.activeTeam = newTeamID
        await this.setState({user})
        this.toggleTeamSwitcherModal()

        const currentUrl = new URL(window.location.href);
        currentUrl.search = '';
        window.history.replaceState({}, document.title, currentUrl.toString());
        this.props.history.push(`/teams/${newTeamID}/controllers`)
        /* window.location.reload(); */
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js